export default {
	methods: {},
	filters: {},
}
